type IconProps = { className?: string };

export function FacebookIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden focusable="false">
      <path
        fill="#1877F2"
        d="M24 12.073C24 5.404 18.627 0 12 0S0 5.404 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.412c0-3.017 1.792-4.686 4.533-4.686 1.312 0 2.686.235 2.686.235v2.956H15.83c-1.49 0-1.955.93-1.955 1.886v2.27h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"
      />
      <path
        fill="#fff"
        d="M16.671 15.563l.532-3.49h-3.328V9.803c0-.956.466-1.886 1.955-1.886h1.514V4.961s-1.374-.235-2.686-.235c-2.741 0-4.533 1.669-4.533 4.686v2.661H7.078v3.49h3.047V24a12.3 12.3 0 003.75 0v-8.437h2.796z"
      />
    </svg>
  );
}

export function InstagramIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden focusable="false">
      <defs>
        <radialGradient id="ig-gradient" cx="30%" cy="107%" r="150%">
          <stop offset="0%" stopColor="#fdf497" />
          <stop offset="5%" stopColor="#fdf497" />
          <stop offset="45%" stopColor="#fd5949" />
          <stop offset="60%" stopColor="#d6249f" />
          <stop offset="90%" stopColor="#285AEB" />
        </radialGradient>
      </defs>
      <rect width="24" height="24" rx="6" fill="url(#ig-gradient)" />
      <path
        fill="#fff"
        d="M12 6.9a5.1 5.1 0 100 10.2 5.1 5.1 0 000-10.2zm0 8.4a3.3 3.3 0 110-6.6 3.3 3.3 0 010 6.6z"
      />
      <circle cx="17.6" cy="6.4" r="1.2" fill="#fff" />
    </svg>
  );
}

export function LinkedinIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden focusable="false">
      <rect width="24" height="24" rx="4" fill="#0A66C2" />
      <path
        fill="#fff"
        d="M7.2 9.6H4.7V19h2.5V9.6zM5.95 8.4a1.45 1.45 0 100-2.9 1.45 1.45 0 000 2.9zM19.3 19h-2.5v-4.9c0-1.23-.44-2.07-1.54-2.07-.84 0-1.34.57-1.56 1.11-.08.2-.1.47-.1.75V19h-2.5s.03-6.62 0-7.31V9.6h2.5v1.33c.33-.51 1.05-1.24 2.55-1.24 1.86 0 3.15 1.22 3.15 3.83V19z"
      />
    </svg>
  );
}

const tiktokPath =
  "M16.6 2h-3.5v13.6a3.1 3.1 0 1 1-3.1-3.1c.3 0 .6 0 .9.1V9.1a6.6 6.6 0 1 0 5.7 6.5V8.7a8.4 8.4 0 0 0 4.9 1.6V6.8a4.9 4.9 0 0 1-4.9-4.8z";

export function TiktokIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden focusable="false">
      <rect width="24" height="24" rx="5" fill="#000" />
      <path fill="#25F4EE" d={tiktokPath} transform="translate(-0.6 -0.6) scale(0.95) translate(0.6 0.6)" />
      <path fill="#FE2C55" d={tiktokPath} transform="translate(1.4 1.4) scale(0.95)" />
      <path fill="#fff" d={tiktokPath} transform="translate(0.6 0.6) scale(0.95)" />
    </svg>
  );
}

export function WhatsappIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden focusable="false">
      <path
        fill="#25D366"
        d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.92 1.17-.15.2-.3.22-.6.07-.3-.15-1.13-.42-2.15-1.33-.8-.71-1.32-1.58-1.47-1.88-.15-.3-.02-.46.13-.61.15-.15.3-.35.45-.52.15-.18.2-.3.3-.5.1-.2.05-.38-.03-.53-.07-.15-.67-1.62-.92-2.21-.24-.58-.49-.5-.67-.5-.17-.01-.37-.01-.57-.01-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.06 2.87 1.21 3.07c.15.2 2.09 3.34 5.07 4.55 2.98 1.2 3.14.87 3.71.82.57-.05 1.83-.75 2.09-1.47.25-.72.25-1.34.17-1.47-.07-.12-.27-.2-.57-.35z"
      />
      <path
        fill="#25D366"
        d="M12.04 0C5.46 0 .1 5.35.1 11.93c0 2.1.55 4.15 1.6 5.96L0 24l6.3-1.65a11.9 11.9 0 005.74 1.46h.01c6.58 0 11.94-5.35 11.94-11.93C23.99 5.35 18.62 0 12.04 0zm0 21.8a9.9 9.9 0 01-5.04-1.38l-.36-.21-3.74.98 1-3.65-.24-.37a9.86 9.86 0 01-1.51-5.24c0-5.47 4.45-9.92 9.93-9.92a9.93 9.93 0 019.92 9.93c0 5.47-4.46 9.86-9.92 9.86z"
      />
    </svg>
  );
}
